import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { UiTagComponent } from '../../atoms/tag/tag.component';
import {
  invoicesSubtotal,
  invoiceSubtotalMatches,
  UiInvoiceSubtotalItem,
} from './invoice-subtotal-check.util';

/** Resumen y validación visual del subtotal de facturas o comprobantes. */
@Component({
  selector: 'ui-invoice-subtotal-check',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiTagComponent],
  templateUrl: './invoice-subtotal-check.component.html',
  styleUrl: './invoice-subtotal-check.component.scss',
})
export class UiInvoiceSubtotalCheckComponent {
  readonly items = input.required<readonly UiInvoiceSubtotalItem[]>();
  readonly expectedSubtotal = input.required<number>();
  readonly singularLabel = input('factura');
  readonly pluralLabel = input('facturas');

  protected readonly subtotal = computed(() =>
    invoicesSubtotal(this.items()),
  );

  protected readonly countLabel = computed(() => {
    const count = this.items().length;
    const label = count === 1 ? this.singularLabel() : this.pluralLabel();
    return `${count} ${label}`;
  });

  protected readonly subtotalText = computed(() =>
    this.subtotal().toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
    }),
  );

  protected readonly matches = computed(
    () => invoiceSubtotalMatches(this.items(), this.expectedSubtotal()),
  );
}
